import { TOKEN_QUERY_PARAMETER, TOKEN_SOURCE_QUERY_PARAMETER, TOKEN_SOURCE_F3D6, TOKEN_VALID_LENGTH, TOKEN_VALID_LENGTH_F3D6, } from '../constants';
import getQueryParameter from './getQueryParameter';
var preValidateToken = function (token, tokenSource) {
    var tokenValidLength = tokenSource === TOKEN_SOURCE_F3D6 ? TOKEN_VALID_LENGTH_F3D6 : TOKEN_VALID_LENGTH;
    var isTokenValid = typeof token === 'string' && token.length === tokenValidLength;
    if (!isTokenValid) {
        throw new Error('Token not valid');
    }
};
var createUrl = function (endpoint) {
    var token = getQueryParameter(TOKEN_QUERY_PARAMETER);
    var tokenSource = getQueryParameter(TOKEN_SOURCE_QUERY_PARAMETER);
    preValidateToken(token, tokenSource);
    if (process.env.NODE_ENV === 'development') {
        return window.avAppConfig.serviceUrl + endpoint + token;
    }
    else {
        return endpoint + token;
    }
};
export default createUrl;
//# sourceMappingURL=createUrl.js.map